export const weatherConfig = [
  {
    id: 'mn',
    name: 'State of MN',
    lat: '46.3',
    lng: '-94.3',
    forecastOffice: 'MPX',
  },
  {
    id: 'minneapolis',
    name: 'MSP Airport',
    lat: '44.8848',
    lng: '-93.2223',
    forecastOffice: 'MPX',
  },
  {
    id: 'saint-paul',
    name: 'St.Paul, MN',
    lat: '44.9530',
    lng: '-93.0967',
    forecastOffice: 'MPX',
  },
  {
    id: 'bemidji',
    name: 'Bemidji, MN',
    lat: '47.4716',
    lng: '-94.8827',
    forecastOffice: 'FGF',
  },
  {
    id: 'brainerd',
    name: 'Brainerd, MN',
    lat: '46.3527',
    lng: '-94.2020',
    forecastOffice: 'DLH',
  },
  {
    id: 'duluth',
    name: 'Duluth, MN',
    lat: '46.7867',
    lng: '-92.1005',
    forecastOffice: 'DLH',
  },
  {
    id: 'ely',
    name: 'Ely, MN',
    lat: '47.9032',
    lng: '-91.8671',
    forecastOffice: 'DLH',
  },
  {
    id: 'eau-claire',
    name: 'Eau Claire, WI',
    lat: '44.8113',
    lng: '-91.4985',
    forecastOffice: 'MPX',
  },
  {
    id: 'fargo',
    name: 'Fargo, ND',
    lat: '46.8772',
    lng: '-96.7898',
    forecastOffice: 'FGF',
  },
  {
    id: 'grand-forks',
    name: 'Grand Forks, ND',
    lat: '47.9337',
    lng: '-97.0280',
    forecastOffice: 'FGF',
  },
  {
    id: 'international-falls',
    name: 'International Falls, MN',
    lat: '48.6003',
    lng: '-93.3975',
    forecastOffice: 'DLH',
  },
  {
    id: 'la-crosse',
    name: 'La Crosse, WI',
    lat: '43.8087',
    lng: '-91.2375',
    forecastOffice: 'ARX',
  },
  {
    id: 'mankato',
    name: 'Mankato, MN',
    lat: '44.1666',
    lng: '-94.0113',
    forecastOffice: 'MPX',
  },
  {
    id: 'moorhead',
    name: 'Moorhead, MN',
    lat: '46.8656',
    lng: '-96.7578',
    forecastOffice: 'FGF',
  },
  {
    id: 'rochester',
    name: 'Rochester, MN',
    lat: '44.0121',
    lng: '-92.4802',
    forecastOffice: 'ARX',
  },
  {
    id: 'saint-cloud',
    name: 'Saint Cloud, MN',
    lat: '45.5579',
    lng: '-94.1489',
    forecastOffice: 'MPX',
  },
  {
    id: 'sioux-falls',
    name: 'Sioux Falls, SD',
    lat: '43.551',
    lng: '-96.7336',
    forecastOffice: 'FSD',
  },
  {
    id: 'thief-river-falls',
    name: 'Thief River Falls, MN',
    lat: '48.1283',
    lng: '-96.1882',
    forecastOffice: 'FGF',
  },
  {
    id: 'virginia',
    name: 'Virginia, MN',
    lat: '47.5233',
    lng: '-92.5366',
    forecastOffice: 'DLH',
  },
  {
    id: 'worthington',
    name: 'Worthington, MN',
    lat: '43.6229',
    lng: '-95.6023',
    forecastOffice: 'BUF',
  },
];
